import { useEffect, useMemo, useRef, useState } from 'react';
import s from './Treasury.module.scss';
import TreasuryDetail from './TreasuryDetail';
import { createPortal } from 'react-dom';
import CPassToken from '@/contracts/passToken';
import { formatCurrency } from '@/utils';
import { getPlayerPoolProfile } from '@/services/player-share';
import { IGetPlayerPoolProfile } from '@/interfaces/api/player-share';
import BigNumber from 'bignumber.js';

interface props {
  profile: any;
  justShowNumber?: boolean;
}

const Treasury = ({ profile, justShowNumber = false }: props) => {
  const [showDetail, setShowDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const passToken = useRef(new CPassToken()).current;
  const feeRef = useRef<any>();
  const [ownerProfile, setOwnerProfile] = useState<IGetPlayerPoolProfile>();

  useEffect(() => {
    if (profile) {
      fetchTreasury();
    }
  }, [profile]);

  const fetchTreasury = async () => {
    const [player, fee] = await Promise.all([
      getPlayerPoolProfile(profile.address),
      passToken.getCircleTreasury({
        twitterId: profile.twitterId,
      }),
    ]);

    setOwnerProfile(player);
    feeRef.current = fee;
  };

  const usdTreasury = useMemo(() => {
    if (ownerProfile && feeRef.current) {
      const btcBN = new BigNumber(feeRef?.current?.amountToken)
        .multipliedBy(ownerProfile.passTokenPrice || 0)
        .plus(feeRef?.current?.amountBTC);
      return new BigNumber(ownerProfile.btcPrice)
        .multipliedBy(btcBN)
        .toString();
    }
    return '0';
  }, [ownerProfile, feeRef.current]);

  if (justShowNumber) {
    return (
      <>
        <div onClick={() => setShowDetail(true)}>
          ${formatCurrency(usdTreasury, 2, 2)}
        </div>
        {createPortal(
          <TreasuryDetail
            show={showDetail}
            onClose={() => {
              setShowDetail(false);
            }}
            profile={ownerProfile}
            feeInfo={feeRef?.current}
          />,
          document.body
        )}
      </>
    );
  }

  return (
    <>
      <div
        // isLoaded={!loading}
        className={s.wrapper}
        onClick={() => setShowDetail(true)}
        // borderRadius={'100px'}
      >
        {/*<img
          width={24}
          alt={'logo-bitcoin-white'}
          src={`${CDN_URL_ICONS}/money-gold.png`}
          style={{ marginRight: '4px' }}
        />*/}
        <p className={s.btcBalance}>Treasury</p>
        <p className={s.btcValue}>${formatCurrency(usdTreasury, 2, 2)}</p>
      </div>
      {createPortal(
        <TreasuryDetail
          show={showDetail}
          onClose={() => setShowDetail(false)}
          profile={ownerProfile}
          feeInfo={feeRef?.current}
        />,
        document.body
      )}
    </>
  );
};

export default Treasury;
